import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import classes from './Footer.module.css';
import CookieSettings from '../Footer/Cookie/CookieSettings';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [showScroll, setShowScroll] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const checkScrollTop = useCallback(() => {
    setShowScroll(window.scrollY > 400);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [checkScrollTop]);

  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.identity}>
          <p className={classes.name}>{t('Footer.headline')}</p>
          <p className={classes.contact}>
            Dahlemer Weg 2, 14169 Berlin
            <span className={classes.separator} aria-hidden="true">
              ·
            </span>
            <a href="tel:+493074685376">030 74685376</a>
          </p>
        </div>
        <p className={classes.copyright}>
          © {new Date().getFullYear()} {t('Footer.headline')}
        </p>
      </div>

      <div className={classes.legal}>
        <a href="/imprint" className={classes.legalLink}>
          {t('Footer.Imprint')}
        </a>
        <a href="/privacy-policy" className={classes.legalLink}>
          {t('Footer.Privacy Policy')}
        </a>
        <a href="/cookie-policy" className={classes.legalLink}>
          {t('Footer.Cookie Policy')}
        </a>
        <button
          type="button"
          className={classes.legalLinkButton}
          onClick={() => setShowSettings(true)}
        >
          {t('Footer.Cookie Settings')}
        </button>
        <a href="/terms-of-use" className={classes.legalLink}>
          {t('Footer.Terms of Service')}
        </a>
      </div>

      <button
        type="button"
        onClick={scrollToTop}
        className={classes.scrollTop}
        aria-label={t('Footer.backToTop')}
        style={{ display: showScroll ? 'flex' : 'none' }}
      >
        <FontAwesomeIcon icon={faChevronUp} />
      </button>

      {showSettings && (
        <CookieSettings onClose={() => setShowSettings(false)} />
      )}
    </footer>
  );
};

export default Footer;
